export const AlertOperators = {
  LESS_THAN: "<",
  LESS_THAN_OR_EQUAL_TO: "<=",
  GREATER_THAN: ">",
  GREATER_THAN_OR_EQUAL_TO: ">=",
  EQUAL_TO: "==",
} as const;
export type AlertOperatorsTypes =
  (typeof AlertOperators)[keyof typeof AlertOperators];
